import React from 'react';

export type Props = {
  touched?: boolean;
  children?: React.ReactNode;
};

export default function InputError(props: Props) {
  let { children, touched } = props;

  return <div className="text-sm text-red-600 mt-1 mb-2">{(touched && children) || <span>&zwnj;</span>}</div>;
}
